import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  const colorMap: Record<string, { bg: string; text: string; border: string }> = {
    primary: { bg: 'bg-primary-100', text: 'text-primary-700', border: 'border-primary-200' },
    accent: { bg: 'bg-accent-100', text: 'text-accent-700', border: 'border-accent-200' },
    secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', border: 'border-secondary-200' },
  };

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              {t('home:sectionCategories')}
            </h2>
            <p className="text-sm text-foreground-500 max-w-md mx-auto">
              {t('home:sectionCategoriesDesc')}
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {categories.map((cat) => {
              const colors = colorMap[cat.color] || colorMap.primary;
              return (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className={`w-11 h-11 flex items-center justify-center rounded-lg ${colors.bg} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${cat.icon} text-lg ${colors.text}`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                    {cat.description}
                  </p>
                  <span className="text-xs text-primary-500 font-medium">
                    {cat.count.toLocaleString()} {t('home:categoryCount')}
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}